import { Injectable } from '@angular/core';
import { AbstractControl, ValidationErrors, Validator } from '@angular/forms';
import { DateUtils } from '../Utils/date.utils';

/**
 * Kontrola, že datum sběru je maximálně 21 dní před podáním žádosti.
**/
@Injectable({
  providedIn: 'root'
})
export class PopSberDoValidator implements Validator {
  private dniPo: number = 21;

  constructor(
    private dateUtils: DateUtils
  ) { }

  validate(control: AbstractControl): ValidationErrors | null {
    if (control.value == void 0 || control.value == '') {
      return null;
    }

    let sberDo = this.dateUtils.getDateWithoutTime(this.dateUtils.addDays(new Date(Date.parse(control.value)), this.dniPo));
    let limitDate = this.dateUtils.getDateWithoutTime(new Date());
    if (sberDo < limitDate) {
      return { 'sberDo': 'Žádost musí být podána nejpozději 21 dnů po ukončení sběru RM.' };
    }
    return null;
  }
}
